// extracted by mini-css-extract-plugin
export default {"modal-header":"GenerateP18Modal_modal-header__TcUsP","close-icon":"GenerateP18Modal_close-icon__2HxqR","modal-body":"GenerateP18Modal_modal-body__R2X+e"};